module.exports = __webpack_public_path__ + "img/UserPlaceholder.69d22460.svg";